"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELeadSource = exports.EOpportunityCustomerInfoSource = exports.EOpportunityInfoType = exports.EOfferType = exports.EOpportunityProgress = exports.EOpportunityState = void 0;
var EOpportunityState;
(function (EOpportunityState) {
    /** Unassigned */
    EOpportunityState["NEW"] = "N";
    /** In progress */
    EOpportunityState["OPEN"] = "O";
    EOpportunityState["CLOSED"] = "C";
    EOpportunityState["POSTPONED"] = "P";
})(EOpportunityState = exports.EOpportunityState || (exports.EOpportunityState = {}));
var EOpportunityProgress;
(function (EOpportunityProgress) {
    EOpportunityProgress["RESERVATION"] = "R";
    EOpportunityProgress["SALE"] = "S";
    EOpportunityProgress["OFFER"] = "O";
    EOpportunityProgress["CONTRACT"] = "C";
    EOpportunityProgress["CREATED"] = "X";
    EOpportunityProgress["NEEDS_ASSIGNEMNT"] = "N";
})(EOpportunityProgress = exports.EOpportunityProgress || (exports.EOpportunityProgress = {}));
var EOfferType;
(function (EOfferType) {
    EOfferType["FINANCE"] = "F";
    /** "Leasing mit Kilometerabrechnung" */
    EOfferType["LEASING"] = "L";
    /** "Restwertleasing" */
    EOfferType["RESIDUAL_LEASING"] = "R";
    EOfferType["CASH"] = "C";
})(EOfferType = exports.EOfferType || (exports.EOfferType = {}));
var EOpportunityInfoType;
(function (EOpportunityInfoType) {
    EOpportunityInfoType["OFFER_RESPONSE"] = "OFFER_RESPONSE";
    EOpportunityInfoType["NOTE"] = "NOTE";
    EOpportunityInfoType["EVENT"] = "EVENT";
    EOpportunityInfoType["RESERVATION"] = "RESERVATION";
    EOpportunityInfoType["SALE"] = "SALE";
    EOpportunityInfoType["AVAILABLE"] = "AVAILABLE";
    EOpportunityInfoType["TEMPLATE"] = "TEMPLATE";
    EOpportunityInfoType["STATE_CHANGE"] = "STATE_CHANGE";
    EOpportunityInfoType["LEAD"] = "LEAD";
    EOpportunityInfoType["ASSIGNMENT"] = "ASSIGNMENT";
    EOpportunityInfoType["EMAIL_INCOMING"] = "EMAIL_INCOMING";
    EOpportunityInfoType["EMAIL_OUTGOING"] = "EMAIL_OUTGOING";
})(EOpportunityInfoType = exports.EOpportunityInfoType || (exports.EOpportunityInfoType = {}));
var EOpportunityCustomerInfoSource;
(function (EOpportunityCustomerInfoSource) {
    EOpportunityCustomerInfoSource["OFFER"] = "OFFER";
})(EOpportunityCustomerInfoSource = exports.EOpportunityCustomerInfoSource || (exports.EOpportunityCustomerInfoSource = {}));
var ELeadSource;
(function (ELeadSource) {
    ELeadSource["MOBILE_DE"] = "MOBILE_DE";
    ELeadSource["AUTOSCOUT24"] = "AUTOSCOUT24";
    ELeadSource["AWI"] = "AWI";
    ELeadSource["OTHER"] = "OTHER";
})(ELeadSource = exports.ELeadSource || (exports.ELeadSource = {}));
